module.exports = __webpack_public_path__ + "img/databaseorange.13535ca8.svg";